import { apiRequest } from './http';
import type { UserGrantsResponse, UsersResponse } from './types';

// §5.5 GET /api/users — 자동완성/검색
export interface UsersQuery {
  q?: string;
  limit?: number;
}

export function fetchUsers(query: UsersQuery = {}, signal?: AbortSignal): Promise<UsersResponse> {
  return apiRequest<UsersResponse>('/users', {
    query: query as { [key: string]: unknown },
    signal,
  });
}

// §5.6 GET /api/users/{email}/grants
export function fetchUserGrants(
  email: string,
  signal?: AbortSignal,
): Promise<UserGrantsResponse> {
  return apiRequest<UserGrantsResponse>(`/users/${encodeURIComponent(email)}/grants`, { signal });
}
